import { Injectable } from '@angular/core';
import {ApiService} from './api.service';

@Injectable()
export class ResourcesService {

    constructor(private apiService: ApiService) { }

    getResources(data) {
        return this.apiService.http_post('/resources/list', data);
    }
    
    addResource(data) {
        return this.apiService.http_post('/resources/add', data);
    }
    
    updateResource(data) {
        return this.apiService.http_post('/resources/update', data);
    }
   
    deleteResource(data) {
        return this.apiService.http_post('/resources/delete', data);
    }
    
    getAllCounties() {
        return this.apiService.http_get('/common/getCounties');
    }
}



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/_services/resources.service.ts